{
  "auth": {
    "Adventure starts here 🚀": "Adventure starts here 🚀",
    "Already have an account?": "Already have an account?",
    "Back To Home": "Back to Home",
    "Back to login": "Back to Login",
    "Confirm Password": "Confirm Password",
    "Doğrula": "Verify",
    "Doğrulama Kodu": "Verification Code",
    "Forgot Password? 🔒": "Forgot Password? 🔒",
    "Geri Dön": "Go Back",
    "Google Authenticator Kodu": "Google Authenticator Code",
    "I agree to": "I agree to",
    "Login": "Login",
    "New Password": "New Password",
    "Password Check": "Password Check",
    "Phone": "Phone",
    "Remember me": "Remember me",
    "Reset Password": "Reset Password",
    "Application Title": "Insurance Management System",
    "logout_message": "Safely logging out...",
    "register_title": "Sign Up",
    "register_description": "Create a new account and explore the benefits",
    "i_accept": "i accept",
    "join_us": "Join Us",
    "join_us_description": "Register now and step into our advantageous world by joining our professional network.",
    "Send Reset Link": "Send Reset Link",
    "Set New Password": "Set New Password",
    "Sign in instead": "Sign in instead",
    "Sign up": "Sign Up",
    "You are not authorized! 🔐": "You are not authorized! 🔐",
    "PermissionDenied": "You don't have permission to access this page. Go back home!",
    "privacy policy & terms": "I have read and agree to the Privacy Policy. I consent to the processing of my personal data.",
    "Form gönderilirken bir hata oluştu:": "An error occurred while submitting the form:",
    "Welcome": "Welcome {title}",
    "Soru": "Question",
    "Cevap": "Answer",
    "Email": "Email",
    "Password": "Password",
    "Ad Soyad": "Full Name",
    "Forgot Password Description": "Enter your email and we'll send you instructions to reset your password",
    "Your new password must be different from previously used passwords": "Your new password must be different from previously used passwords",
    "Lütfen 6 haneli güvenlik kodunu girin": "Please enter your 6 digit security code",
    "İki Adımlı Doğrulama": "Two Step Verification",
    "Doğrulama kodu gönderildi": "Verification code sent.",
    "Kodu almadınız mı?": "Didn't get the code?",
    "New on our platform?": "New on our platform?",
    "Create an account": "Create an account",
    "Make your app management easy and fun!": "Make your app management easy and fun!",
    "Privacy Policy Title": "Privacy Policy & Terms",
    "Please Login": "Please log in to your account to continue",
    "Switch Account": "Log in with a different account",
    "Welcome Back": "Welcome Back",
    "Invalid Captcha": "Please check the security code.",
    "Login Title": "Log In",
    "Back to Login Page": "Giriş Sayfasına Dön",
    "Last updated": "Son Güncelleme",
    "Hava Açık": "Hava Açık",
    "Az Bulutlu": "Az Bulutlu",
    "Parçalı Bulutlu": "Parçalı Bulutlu",
    "Kapalı": "Kapalı",
    "Sisli": "Sisli",
    "Çiseleme": "Çiseleme",
    "Yağmurlu": "Yağmurlu",
    "Hafif Yağmur": "Hafif Yağmur",
    "Şiddetli Yağmur": "Şiddetli Yağmur",
    "Kar Yağışlı": "Kar Yağışlı",
    "Fırtına": "Fırtına",
    "Bilinmiyor": "Bilinmiyor",
    "Hissedilen": "Hissedilen",
    "Veri yükleniyor...": "Veri yükleniyor...",
    "Gündüz": "Gündüz",
    "Gece": "Gece",
    "Şimdi Yenile": "Şimdi Yenile"
  }
}
